'use strict';

// Converted from CoffeeScript to JavaScript - ETNA Authenticator Logout Directive
intra_module.directive("logout", function() {
    return {
        restrict: "A",
        scope: {},
        controller: "logoutCtrl"
    };
});

intra_module.controller("logoutCtrl", ['$element', 'identity', function($element, identity) {
    $element.on("click", function() {
        return identity.$logout();
    });
}]);